import React from 'react'
import styled from 'styled-components'

import { Sub } from '../Typography'

const Section = styled.div`
  width: 15rem;
  z-index: 3;

  @media (max-width: 750px) {
    width: 100%;
    order: 2;
    margin-top:3rem;
    padding-left: 1rem;
  }
`

const LeftContent = () =>
  <Section className='left-content'>
    <Sub>
      <a href='/terms-of-service' className='footer__link'>Terms</a> | <a href='https://sequence.xyz/privacy' className='footer__link'>Privacy Policy</a>
    </Sub>

    <br />

    <Sub>
      © 2026 Polygon Labs. All rights reserved.
    </Sub>

  </Section>

export default LeftContent
